import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { ConsolidatedSidebar } from './ConsolidatedSidebar';
import appConfig from '../../utils/appConfig';
import '../../css/App.css';

export const Layout = () => {
  const isSingleNetworkMode = appConfig.isSingleNetworkMode();

  return (
    <div className="app-container">
      <Header />
      <div className={isSingleNetworkMode ? "main-layout main-layout-single" : "main-layout"}>
        {!isSingleNetworkMode && (
          <aside className="left-sidebar">
            <ConsolidatedSidebar />
          </aside>
        )}
        <main className="main-content">
          <Outlet />
        </main>
      </div>
      <Footer />
    </div>
  );
};
